import { ApplicationStatus, BillingPreference, FeeType } from '@/types/api.ts';
import { PostalAddress } from '@/types/postal-address.ts';

export type ApplicationType = 'residential' | 'commercial';

export type ServiceLocationStatus = 'new' | 'existing';

export interface ServiceLocation {
  havingTroubleWithMeterNumber?: boolean;
  requestedConnectDate?: string;
  serviceDescription?: string;
  meterNumber?: string;
  serviceAddressLine1?: string;
  serviceAddressLine2?: string;
  serviceAddressCity?: string;
  serviceAddressState?: string;
  serviceAddressZip?: string;
  status: ServiceLocationStatus;
  parcelId?: string;
}

export interface InitialIntakeResponse {
  nextStep: 'continue' | 'verify_email';
  applicationId: number;
}

export interface ServiceLocationResponse {
  nextStep: 'continue' | 'submitted' | 'service_unavailable' | 'service_unavailable_cot';
}

export interface Fee {
  id: number;
  type: FeeType;
  description: string;
  standardAmount?: number;
  prepaidAmount?: number;
}

export type ServiceStatus = 'residential' | 'commercial' | 'unavailable' | 'unavailable_cot';

export interface Service {
  id: number;
  description: string;
  isPreferenceEditable?: boolean;
  billingPreference: BillingPreference;
  status: ServiceStatus;
}

export interface BillingState {
  isPrepaidAvailable: boolean;
  serviceAddress: PostalAddress;
  fees: Fee[];
  services: Service[];
  prepaidMinimumToStart: number;
}

export function formatBillingPreference(preference: BillingPreference) {
  switch (preference) {
    case 'prepaid':
      return 'Prepaid';
    case 'standard':
      return 'Standard';
  }
}

export function formatApplicationStatus(status: ApplicationStatus) {
  switch (status) {
    case 'worked_by_applicant':
      return 'In Progress';
    case 'open':
      return 'Submitted';
    case 'completed':
      return 'Completed';
    case 'on_hold':
      return 'Submitted';
    case 'cancelled':
      return 'Cancelled';
  }
}

export interface Application {
  readonly id: number;
  readonly status: ApplicationStatus;
  readonly serviceLocation: ServiceLocation;
  readonly billingPreferences: BillingState;
  readonly createdAt: string;
}
